import React from "react";
import { useAuth } from "../lib/auth";
import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";

// R1c dead-click fix F1+F2 (Round 2) — Global impersonation banner.
// Mounted once in App.js above <Routes>. Subscribes to AuthCtx.impersonation
// so it mounts the instant `startImpersonation()` resolves, regardless of
// which page triggered it (top-bar PortalSwitcher, OwnerCommandCenter quick
// action, or PortalSwitch picker). No page-local banner instances.
//
// Testids honored by the tester:
//   - outer: `portal-current-impersonation` (primary)
//     + `impersonation-banner` retained for pre-R1c tests.
//   - exit:  `portal-stop-impersonation` (primary)
//     + `impersonation-exit-btn` and `client-portal-return-to-owner`
//       retained for R1b-α tests (see Fix #6).
export default function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuth();
  if (!impersonation) return null;
  return (
    <div
      role="alert"
      aria-live="polite"
      className="w-full h-9 bg-erf-dark border-b-2 border-erf-gold flex items-center justify-between px-4 sticky top-0 z-[60]"
      data-testid="portal-current-impersonation"
      data-testid-legacy="impersonation-banner"
      id="impersonation-banner"
    >
      <div className="flex items-center gap-3">
        <span className="bg-erf-gold text-erf-dark font-mono font-bold text-[10px] px-2 py-0.5 rounded-sm uppercase tracking-wider">
          OWNER VIEW AS
        </span>
        <span className="text-erf-cream text-xs font-nav" data-testid="portal-current-impersonation-label">
          {impersonation.label}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={stopImpersonation}
        className="h-7 text-[11px] px-2.5 bg-erf-cream/10 hover:bg-erf-cream/20 text-erf-cream border-erf-cream/30 min-h-[28px]"
        aria-label="Return to Owner Command Center"
        title="Return to Owner Command Center"
        data-testid="portal-stop-impersonation"
      >
        <ArrowLeft className="w-3 h-3 mr-1" aria-hidden="true" />
        {/* Legacy testids retained on inner span so existing tests still find them. */}
        <span
          data-testid="client-portal-return-to-owner"
        >
          <span data-testid="impersonation-exit-btn">Return to Owner</span>
        </span>
      </Button>
    </div>
  );
}
